export default __webpack_public_path__ + "static/media/bg404.66226bb8.png";